module.exports = __webpack_public_path__ + "static/media/bfile-classic_car.5650d3d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-classic_car.svg
// module id = 257
// module chunks = 0